import styled from 'styled-components';

export const UiSettingBlock = styled.div`
  width: 100%;
  >* {
    margin: 4px 8px;
  }
`;